module.exports = __webpack_public_path__ + "static/dummyImage-8636b74dbb6e0222edbeb599196dbed8.png";